import checkoutSlice from "../slices/checkoutSlice";

export const checkoutReducers = {
  checkout: checkoutSlice,
};
